import InventoryCell from './component'

export default InventoryCell
